/**
 * Status eines Uebertragungsversuchs -- Punkt + Text, optional die gelbe "seitdem geaendert"-Pille
 * und ein grauer Fehlertext darunter (D-05, D-24; Sketch 025 `statusHtml`/`changedHtml`). Geteilt
 * von `TransferList` (Tabellenzeile) und `TransferDetailDrawer` (Kopf der Seitenleiste). Alle Texte
 * kommen fertig vom Server (`statusLabel`, `errorSummary`) -- keine Ableitung im Frontend.
 *
 * Erkennbar, aber nicht grell (D-05): Fehlversuche zeigen einen transparenten, rot umrandeten Punkt
 * statt eines gefuellten roten Flaechen und einen ruhigen grauen Fehlertext statt einer Fehlerbox.
 */
import type { CSSProperties } from 'react';
import { statusPalette } from '../../theme/colors';
import type { TransferEntryStatus } from '../../types/statistikPortalTransfer';
import classes from './TransferList.module.css';

const statusColorVars = {
  '--transfer-status-ok-color': statusPalette.freigegeben.fg,
  '--transfer-status-fail-color': statusPalette.fehler.fg,
  '--transfer-changed-bg': statusPalette.eingereicht.bg,
  '--transfer-changed-border': statusPalette.eingereicht.border,
  '--transfer-changed-fg': statusPalette.eingereicht.fg,
} as CSSProperties;

export interface TransferStatusProps {
  status: TransferEntryStatus;
  statusLabel: string;
  changedSince: boolean;
  /** Nur in der Liste gesetzt -- die Seitenleiste zeigt den Fehlertext in der Antwortbox. */
  errorSummary?: string | null;
}

export function TransferStatus({
  status,
  statusLabel,
  changedSince,
  errorSummary,
}: TransferStatusProps) {
  const failed = status === 'failed';

  return (
    <span className={classes.statusStack} style={statusColorVars}>
      <span className={`${classes.status} ${failed ? classes.statusFailed : ''}`}>
        <span className={classes.statusDot} />
        {statusLabel}
        {changedSince && (
          <span
            className={classes.changedPill}
            title="Die aktuelle Rechnung weicht von den übertragenen Zeilen ab"
          >
            seitdem geändert
          </span>
        )}
      </span>
      {errorSummary && <span className={classes.errorSummary}>{errorSummary}</span>}
    </span>
  );
}
